import arrayFrom from './array-from';
const defaultSelector = 'linearGradient, radialGradient, pattern, mask, clipPath';
/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
export default function (svg, selector = defaultSelector) {
    arrayFrom(svg.querySelectorAll('symbol')).forEach((symbol) => {
        arrayFrom(symbol.querySelectorAll(selector)).forEach((node) => {
            symbol.parentNode.insertBefore(node, symbol);
        });
    });
    return svg;
}
